import { render, staticRenderFns } from "./BBCheckbox.vue?vue&type=template&id=1e7d35c4&scoped=true"
import script from "./BBCheckbox.vue?vue&type=script&lang=ts"
export * from "./BBCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./BBCheckbox.vue?vue&type=style&index=0&id=1e7d35c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7d35c4",
  null
  
)

export default component.exports